import type { FaireProductEntity } from "../../entity_types/product";

export const p_2nvdjc8rf6: FaireProductEntity = {
  token: "p_2nvdjc8rf6",
  type: "product",
  name: "Cat Matchbook",
  brandToken: "b_b703e67f",
  brandName: "A Shop of Things",
  imageUrl:
    "https://cdn.faire.com/fastly/9a8b4bdddc92fd0b32d2c27bbefdf4a90a82857a898a67a860a65765ed1f2b39.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca699bf16cfaeea9e95c7a1bb725b1cec620d496310603d16bfc87a8e151e956.jpeg",
    "https://cdn.faire.com/fastly/4ccb3c08a228cd04e0c57ee4b82726c54a8605a7863191b293bcb23630e87468.jpeg",
    "https://cdn.faire.com/fastly/c722d4d99142a30273aaf21416af0c80063507ddcbacd23c2db685b70e1bab12.jpeg",
    "https://cdn.faire.com/fastly/e241480d44d9bcce95047e80af1f4e3d1761d4902ddf081ad171a20710da1460.jpeg",
    "https://cdn.faire.com/fastly/2a8a67e88bbab4aedd4cc2c48cf14577fea953f50a28cac9be3f555f4a876a40.jpeg",
    "https://cdn.faire.com/fastly/281a0297aa23fca652d96a356e677c1aa89e605d93113ea8fd10c0fc94d9b1ea.jpeg",
    "https://cdn.faire.com/fastly/a0ab5c8cd882783d67f564171ee6f6e888ad4be0eaaa889936e4b6a16dd11091.jpeg",
  ],
  priceDollars: 4.16,
  description:
    '\nOur newest matches feature your favorite pets!\n\nJust. Look. At. How. CUTE! Adorable cat illustrations cover this matchbook, inside and out, even on the matches themselves! Comes with 10 matches. Drawn by the talented Claire Shadomy!\n\nMatchbook is 2" x 2.25" \n\nPlease be careful when using this product and keep away from children! We can not be held liable for any accidents that occur when using this product.\n\nMade in Germany. Lighters/matches can NOT be shipped internationally.\n\nThis design is the sole property of A Shop of Things and cannot be reproduced or copied for any reason without permission beforehand. ©\n',
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:05.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
